module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Red.c6ee3a53.png";